module.exports = __webpack_public_path__ + "img/img_5.dbf25c7b.svg";